import Chip from "@mui/material/Chip"
import Tooltip from "@mui/material/Tooltip"

import useTranslate from "@hooks/use_translate"
import { type TrackingLinksStatus } from "@models/campaign_links"
import { formatDate } from "@utils/functions/formatDate"

export default function CampaignLinksStatus({
  status
}: {
  status: TrackingLinksStatus
}) {
  const { translate, currentLanguage } = useTranslate()

  if (!status.disabled) {
    return (
      <Chip
        size="small"
        color="success"
        variant="outlined"
        label={translate("campaign_links_on")}
      />
    )
  }

  const details = [
    status.reason,
    status.disabledBy,
    status.disabledAt ? formatDate(currentLanguage, status.disabledAt) : null
  ]
    .filter(Boolean)
    .join(" · ")

  return (
    <Tooltip title={details}>
      <Chip
        size="small"
        color="error"
        label={translate("campaign_links_off")}
      />
    </Tooltip>
  )
}
